import type { HTMLAttributes, ReactNode } from 'react';
import { classNames } from '@/lib/format';
import { Tooltip } from './Tooltip';

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'accent';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  children: ReactNode;
}

/**
 * `title` on a Badge renders as OUR tooltip, not the browser's — same rule as
 * Button. Badges are used as status chips whose whole job is to be a short
 * label with a longer explanation behind it, so a native `title` here is both
 * the ugliest and the most frequently hovered version of the mismatch.
 */
export function Badge({ tone = 'neutral', className, children, title, ...rest }: BadgeProps) {
  const badge = (
    <span
      className={classNames('badge', `badge--${tone}`, className)}
      style={title ? { cursor: 'help', ...rest.style } : rest.style}
      {...rest}
    >
      {children}
    </span>
  );
  if (!title) return badge;
  return <Tooltip content={title}>{badge}</Tooltip>;
}
